import React from "react";

const RefreshIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4704_186"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="25"
      >
        <rect x="0.814575" y="0.647614" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4704_186)">
        <path
          d="M12.8146 20.6476C10.5812 20.6476 8.68958 19.8726 7.13958 18.3226C5.58958 16.7726 4.81458 14.8809 4.81458 12.6476C4.81458 10.4143 5.58958 8.52261 7.13958 6.97261C8.68958 5.42261 10.5812 4.64761 12.8146 4.64761C13.9646 4.64761 15.0646 4.88511 16.1146 5.36011C17.1646 5.83511 18.0646 6.51428 18.8146 7.39761V4.64761H20.8146V11.6476H13.8146V9.64761H18.0146C17.4812 8.71428 16.7521 7.98095 15.8271 7.44761C14.9021 6.91428 13.8979 6.64761 12.8146 6.64761C11.1479 6.64761 9.73124 7.23095 8.56458 8.39761C7.39791 9.56428 6.81458 10.9809 6.81458 12.6476C6.81458 14.3143 7.39791 15.7309 8.56458 16.8976C9.73124 18.0643 11.1479 18.6476 12.8146 18.6476C14.0979 18.6476 15.2562 18.2809 16.2896 17.5476C17.3229 16.8143 18.0479 15.8476 18.4646 14.6476H20.5646C20.0979 16.4143 19.1479 17.8559 17.7146 18.9726C16.2812 20.0893 14.6479 20.6476 12.8146 20.6476Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};

export default RefreshIcon;
